import React, { useState, useEffect } from "react"
import { useGlobalContext } from "../../data/GlobalContext"

export default function DoubleUpChallenge() {
  const {
    doubleUpLoading,
    doubleUpTurnover,
    doubleUpMaxAmount,
    doubleUpTarget,
  } = useGlobalContext()
  const [loading, setLoading] = useState(true)
  const [isPayment, setIsPayment] = useState(false)
  const [isShowDoubleUp, setIsShowDoubleUp] = useState(true)
  const [amount, setAmount] = useState("")
  const [showWidget, setShowWidget] = useState(true)
  const [amountError, setAmountError] = useState("")

  const [isLoggedIn, setIsLoggedIn] = useState(false)

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false)
    }, 1000)
    return () => clearTimeout(timer)
  }, [])

  if (!showWidget || !isLoggedIn) return null

  if (doubleUpLoading) {
    return (
      <div className="double-up-challenge-loading">
        <img src="/images/double-up/FGH.png" alt="" />
        <p></p>
      </div>
    )
  }

  const proceedPayment = () => {
    setIsPayment(true)
    setIsShowDoubleUp(false)
  }

  const handleAmountChange = (e) => {
    const val = e.target.value

    if (val === "" || /^\d+$/.test(val)) {
      setAmount(val)

      const num = parseInt(val, 10)

      // Only validate if it's a valid number
      if (!isNaN(num)) {
        if (num < 500) {
          setAmountError("Minimum amount is ₱500")
        } else if (num > doubleUpMaxAmount) {
          setAmountError(`Maximum amount is ₱${doubleUpMaxAmount}`)
        } else {
          setAmountError("")
        }
      } else {
        setAmountError("")
      }
    }
  }

  const handleAmountBlur = () => {
    if (amount === "") return

    let num = parseInt(amount, 10)
    if (isNaN(num)) num = 500

    if (num < 500) {
      num = 500
      setAmountError("") // Auto-correct, so remove error
    } else if (num > doubleUpMaxAmount) {
      num = doubleUpMaxAmount
      setAmountError("") // Auto-correct, so remove error
    }

    setAmount(num.toString())
  }

  const handleClose = () => {
    setShowWidget(false)
  }

  const handlePaymentSubmit = () => {}

  return (
    <>
      {doubleUpTurnover >= 100000 && (
        <div className="double-up-challenge-container">
          {isShowDoubleUp && (
            <div className="double-up-challenge-content">
              <div className="double-up-challenge-content-img">
                <img
                  src="/images/double-up/DOUBLE-UP_CHALLENGE.webp"
                  alt="Double Up Challenge"
                />
                <div className="double-up-challenge-btn">
                  <button onClick={proceedPayment}>Proceed</button>
                </div>
              </div>
            </div>
          )}

          {isPayment && (
            <div className="double-up-challenge-content double-up-challenge-amount">
              <img
                src="/images/double-up/DOUBLE-UP-ASSET.webp"
                alt="Double Up Challenge"
              />

              {/* MAIN NUMBER INPUT */}
              <div className="double-up-challenge-amount--input">
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={amount}
                  onChange={handleAmountChange}
                  onBlur={handleAmountBlur}
                  placeholder="Enter Amount"
                  max={doubleUpMaxAmount}
                />
                {amountError && <p className="error-text">{amountError}</p>}
              </div>

              {/* QUICK-PICK BUTTONS */}
              <div className="double-up-challenge-amount--input-input">
                <button
                  type="button"
                  className={amount === "500" ? "selected" : ""}
                  onClick={() => setAmount("500")}
                >
                  ₱500
                </button>

                {doubleUpMaxAmount > 500 && (
                  <button
                    type="button"
                    className={
                      amount === doubleUpMaxAmount.toString() ? "selected" : ""
                    }
                    onClick={() => {
                      const allowed = Math.min(5000, doubleUpMaxAmount)
                      setAmount(allowed.toString())
                    }}
                  >
                    ₱{doubleUpMaxAmount}
                  </button>
                )}
              </div>

              <div className="double-up-challenge-btn">
                <button onClick={handlePaymentSubmit}>Submit</button>
              </div>
            </div>
          )}

          <div className="double-up-challenge-close-btn">
            <button onClick={handleClose}>Close</button>
          </div>
          <div className="double-up-challenge-info">
            <p>How it works:</p>
            {doubleUpTurnover != null ? (
              <p>
                Double your turnover from last week:{" "}
                <strong>{Number(doubleUpTurnover).toLocaleString()}</strong>
              </p>
            ) : (
              <p>Couldn’t load your turnover. Please try again later.</p>
            )}
            <p>
              Your target turnover before Monday at 11:59 AM:{" "}
              <strong> {Number(doubleUpTarget).toLocaleString()}</strong>
            </p>
            <p>Are you up for a challenge?</p>
          </div>
        </div>
      )}
    </>
  )
}
